import React, { Component } from "react";
import { Link } from "react-router-dom";
import EmpresaContext from "../../context";
import { Empresa } from "smart-imob-types";
import styled from "styled-components";
import { BuilderImg } from "../../builder-context";
import {
  Facebook,
  Instagram,
  Tiktok,
  Youtube,
  Whatsapp
} from "@styled-icons/fa-brands";

const NavbarV2Style = styled.div<NavbarV2Props>`
  font-weight: 200;
  .navbar {
    background-color: ${props => props.empresa.palleta.cor_header};
  }
  .navbar-area:not(.navbar-area-fixed)
    .nav-container
    .navbar-collapse
    .navbar-nav
    li {
    a {
      ${props =>
        props.empresa.info_gen &&
        props.empresa.info_gen.navbar_v2_text_color &&
        (props.location === "/" ||
          props.empresa.info_gen["page-header-overlay"]) &&
        `
        color: ${props.empresa.info_gen.navbar_v2_text_color};
      `};
    }
    &:hover a {
      color: ${props => props.empresa.palleta.cor_primaria};
    }
    & a:hover {
      color: ${props => props.empresa.palleta.cor_primaria};
    }
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li a {
    color: rgb(255, 255, 255);
  }
  .navbar-area-fixed {
    background: ${props => props.empresa.palleta.cor_header_fixed};
  }
  .navbar-area
    .nav-container
    .navbar-collapse
    .navbar-nav
    li.menu-item-has-children:before {
    color: ${props => props.empresa.palleta.cor_primaria};
    ${props =>
      props.empresa.info_gen &&
      props.empresa.info_gen.navbar_v2_text_color &&
      `
      color: ${props.empresa.info_gen.navbar_v2_text_color};
    `};
  }
  .btn-nav {
    color: #fff;
    border: 1px solid #fff;
    border-radius: 25px;
    &:hover {
      background: ${props => props.empresa.palleta.cor_primaria || "#171717"};
    }
    .right {
      padding: 0;
    }
    ${props =>
      props.empresa.info_gen &&
      props.empresa.info_gen.navbar_v2_text_color &&
      (props.location === "/" ||
        props.empresa.info_gen["page-header-overlay"]) &&
      `
      color: ${props.empresa.info_gen.navbar_v2_text_color};
      border: 1px solid ${props.empresa.info_gen.navbar_v2_text_color};
      &:hover {
        background: ${props => props.empresa.palleta.cor_primaria || "#171717"};
        color: #fff;
        border: 1px solid #fff;
      }
    `};
  }
  .nav-social-list {
    display: flex;
    gap: 15px;
    list-style: none;
    padding: 25;
    margin: 0;
    a {
      border-radius: 4px;
      color: #fff;
      display: inline-flex;
      padding: 4px;
      svg {
        width: 24px;
        height: 24px;
      }
      &:hover {
        background: #fff;
        color: #363636;
      }
    }
    &.mobile {
      display: none;
    }
    @media screen and (max-width: 991px) {
      display: none;
      &.mobile {
        display: flex;
        li {
          border-bottom: none;
        }
      }
    }
  }
  @media screen and (max-width: 991px) {
    .navbar-area:not(.navbar-area-fixed)
      .nav-container
      .navbar-collapse
      .navbar-nav
      li
      a {
      color: #282828;
    }
  }
`;

interface NavbarV2Props {
  empresa: Empresa;
}

class NavbarV2 extends Component {
  context!: Empresa;
  state = {
    location: ""
  };
  componentDidMount() {
    try {
      if (this.context.nav_bar_fixed) {
        //eu odeio jquery
        //@ts-ignore
        const $ = window.$;
        $(window).on("scroll", function() {
          /*---------------------------------------
          sticky menu activation && Sticky Icon Bar
          -----------------------------------------*/
          var mainMenuTop = $(".navbar-area");
          if ($(window).scrollTop() >= 1) {
            mainMenuTop.addClass("navbar-area-fixed");
          } else {
            mainMenuTop.removeClass("navbar-area-fixed");
          }

          var ScrollTop = $(".back-to-top");
          if ($(window).scrollTop() > 1000) {
            ScrollTop.fadeIn(1000);
          } else {
            ScrollTop.fadeOut(1000);
          }
        });
      }
    } catch (_) {}
    this.setState({
      location: window.location.pathname
    });
  }
  render() {
    let redesSociaisIcon = {
      facebook: <Facebook />,
      tiktok: <Tiktok />,
      youtube: <Youtube />,
      instagram: <Instagram />,
      whatsapp: <Whatsapp />
    };
    return (
      <NavbarV2Style empresa={this.context} location={this.state.location}>
        <div className="navbar-area">
          <nav className="navbar navbar-area navbar-expand-lg">
            <div className="container nav-container">
              <div className="responsive-mobile-menu">
                <button
                  className="menu toggle-btn d-block d-lg-none"
                  data-toggle="collapse"
                  data-target="#realdeal_main_menu"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="icon-left" />
                  <span className="icon-right" />
                </button>
              </div>
              {this.context.logo ? (
                <div
                  className="logo readeal-top"
                  {...BuilderImg("bb_img_logo")}
                >
                  <Link to="/">
                    <img
                      src={this.context["bb_img_logo"] || this.context.logo}
                      alt="logo"
                      style={
                        this.context["navbar_lower_logo"]
                          ? { maxHeight: 110, padding: 4, marginTop: 40 }
                          : { maxHeight: 110, padding: 4 }
                      }
                    />
                  </Link>
                </div>
              ) : null}
              {this.context["envie_seu_imovel_mobile"] ||
              this.context["envie_seu_imovel_mobile"] === undefined
                ? (this.context.envie_seu_imovel === undefined ||
                    this.context.envie_seu_imovel === true) && (
                    <div className="nav-right-part nav-right-part-mobile">
                      <Link className="btn btn-yellow" to="/registrar-imovel">
                        <span className="right">
                          <i className="la la-plus" />
                        </span>{" "}
                        {this.context["envie_seu_imovel_txt"] ||
                          "Cadastre seu Imóvel"}
                      </Link>
                    </div>
                  )
                : null}
              <div className="collapse navbar-collapse" id="realdeal_main_menu">
                <ul className="navbar-nav menu-open readeal-top">
                  {this.context.info_gen &&
                  this.context.info_gen["menu_options"] ? (
                    this.context.info_gen["menu_options"].map(option => (
                      <li>
                        <Link to={option.link}>{option.nome}</Link>
                      </li>
                    ))
                  ) : (
                    <>
                      <li>
                        <Link to="/lista">IMÓVEIS</Link>
                      </li>
                      <li>
                        <Link to="/sobre">INSTITUCIONAL</Link>
                      </li>
                      {/* <li>
                      <Link to="/">BLOG</Link>
                    </li> */}
                      <li>
                        <Link to="/contato">CONTATO</Link>
                      </li>
                    </>
                  )}
                  {this.context.info_gen &&
                    this.context.info_gen["navbar_redes_sociais"] && (
                      <ul className="nav-social-list mobile">
                        {this.context.redes_sociais.map(item => (
                          <li>
                            <a href={item.url}>{redesSociaisIcon[item.nome]}</a>
                          </li>
                        ))}
                      </ul>
                    )}

                  {this.context.links_extras &&
                    this.context.links_extras.links &&
                    this.context.links_extras.links.length > 0 && (
                      <li className="menu-item-has-children">
                        <a href="#">
                          {this.context.links_extras.titulo || "Links extras"}
                        </a>
                        <ul className="sub-menu">
                          {this.context.links_extras.links.map(link => (
                            <li key={"nav" + link.nome}>
                              <a target="_blank" rel="noopener" href={link.url}>
                                {link.nome}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </li>
                    )}
                </ul>
              </div>
              {(this.context.envie_seu_imovel === undefined ||
                this.context.envie_seu_imovel === true) && (
                <div className="nav-right-part nav-right-part-desktop readeal-top">
                  <Link className="btn btn-nav" to="/registrar-imovel">
                    <span className="right">
                      <i className="la la-plus" />
                    </span>{" "}
                    {this.context["envie_seu_imovel_txt"] ||
                      "Cadastre seu Imóvel"}
                  </Link>
                </div>
              )}
              {this.context.info_gen &&
                this.context.info_gen["navbar_redes_sociais"] && (
                  <ul className="nav-social-list">
                    {this.context.redes_sociais.map(item => (
                      <li>
                        <a href={item.url}>{redesSociaisIcon[item.nome]}</a>
                      </li>
                    ))}
                  </ul>
                )}
            </div>
          </nav>
        </div>
      </NavbarV2Style>
    );
  }
}

NavbarV2.contextType = EmpresaContext;

export default NavbarV2;
